// src/api/lookups.js
import api from './axios';

// GET /api/timeframes -> returns either {data:[...]} or [...]
export async function listTimeframes() {
    const res = await api.get('/api/timeframes');
    const rows = Array.isArray(res?.data?.data) ? res.data.data : res?.data;
    return Array.isArray(rows) ? rows : [];
}